import ServiceStationLocator from "./ServiceStationLocator";

export default ServiceStationLocator;
